module.exports = __webpack_public_path__ + "static/media/construction.46c4f139.png";